import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { InstagramLogo, LinkedinLogo, FacebookLogo, YoutubeLogo, ArrowUpRight } from "@phosphor-icons/react";
import { BRAND } from "@/data/content";

const COLS = [
  { title: "Explore", links: [["Home", "/"], ["About Us", "/about"], ["Projects", "/projects"], ["Amenities", "/amenities"], ["Gallery", "/gallery"]] },
  { title: "Connect", links: [["Construction Updates", "/construction-updates"], ["Channel Partners", "/channel-partner"], ["Insights", "/blog"], ["Careers", "/careers"], ["Contact", "/contact"]] },
  { title: "Legal", links: [["Privacy Policy", "/legal"], ["Terms of Use", "/legal"], ["FAQ", "/faq"], ["RERA Disclosure", "/legal"]] },
];

export function Footer() {
  const [email, setEmail] = useState("");
  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast.success("You're subscribed to Aureon Insights.");
    setEmail("");
  };
  return (
    <footer className="relative border-t border-white/10 bg-ink" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 py-20 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="text-gold text-2xl">&#9670;</span>
              <span className="font-serif text-3xl font-medium text-white">Aureon<span className="text-gold">.</span></span>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/50">
              Crafting landmark residences for over two decades. Aureon Estates builds spaces that endure — with architectural precision, integrity and enduring value.
            </p>
            <form onSubmit={subscribe} className="mt-8 max-w-sm" data-testid="newsletter-form">
              <label className="overline">Aureon Insights Newsletter</label>
              <div className="mt-3 flex items-center border-b border-white/20 focus-within:border-gold">
                <input
                  value={email} onChange={(e) => setEmail(e.target.value)} type="email"
                  placeholder="Your email address" data-testid="newsletter-input"
                  className="w-full bg-transparent py-3 text-sm text-white placeholder:text-white/30 focus:outline-none"
                />
                <button type="submit" data-testid="newsletter-submit" className="text-gold" aria-label="Subscribe"><ArrowUpRight size={22} /></button>
              </div>
            </form>
          </div>

          {COLS.map((c) => (
            <div key={c.title}>
              <h4 className="overline">{c.title}</h4>
              <ul className="mt-5 space-y-3">
                {c.links.map(([label, to], i) => (
                  <li key={i}>
                    <Link to={to} className="text-sm text-white/60 transition-colors hover:text-gold">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 grid gap-6 border-t border-white/10 pt-10 md:grid-cols-2">
          <div className="space-y-2 text-sm text-white/50">
            <p className="text-white/70">{BRAND.address}</p>
            <p>{BRAND.phone} · {BRAND.email}</p>
            <p className="text-xs text-white/40">{BRAND.rera}</p>
          </div>
          <div className="flex items-start gap-4 md:justify-end">
            {[InstagramLogo, LinkedinLogo, FacebookLogo, YoutubeLogo].map((I, i) => (
              <a key={i} href="#" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white/60 transition-all hover:border-gold hover:text-gold" aria-label="social">
                <I size={18} />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-5 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="flex h-16 w-24 shrink-0 items-center justify-center overflow-hidden rounded-sm bg-white p-1">
              <img src="/brand/celestial-mind-creations-techspace.png" alt="Celestial Mind Creations" className="h-full w-full object-contain" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.18em] text-white/40">A demonstration created under</p>
              <p className="mt-1 font-serif text-xl text-white">Celestial Mind Creations <span className="text-gold">TechSpace</span></p>
            </div>
          </div>
          <a href={`mailto:${BRAND.email}`} className="text-sm text-gold transition-colors hover:text-white">{BRAND.email}</a>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-xs text-white/40">
          <p className="leading-relaxed">
            Disclaimer: This is a conceptual website for the fictional brand "Aureon Estates", created under Celestial Mind Creations TechSpace for demonstration. Images are indicative. Prices, plans and specifications are illustrative and do not constitute a legal offer. All projects are represented as RERA-registered.
          </p>
          <p className="mt-4">© {new Date().getFullYear()} Aureon Estates. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
